<template>
	<div class="text-right p-4">
		<form ref="product" @submit.prevent>
			<ty-row :gutter="2">
				<ty-col :xs="24" :sm="7" :md="7" :lg="7" :xl="4">
					<upload v-model="productModel.image_id" class="mt-4 pt-3" width="140px" />
				</ty-col>
				<ty-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
					<ty-row :gutter="10">
						<ty-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
							<ty-input label="نام محصول" v-model="productModel.name" :required="true" />
						</ty-col>
						<ty-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
							<ty-input label="کد محصول" v-model="productModel.barcode" />
						</ty-col>
					</ty-row>
				</ty-col>
				<ty-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
					<ty-row :gutter="10">
						<ty-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
							<ty-currency-input label="قیمت واحد" v-model="productModel.price" :required="true">
								<span slot="suffix" class="ty-color-primary">تومان</span>
							</ty-currency-input>
						</ty-col>
						<ty-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
							<ty-currency-input label="قیمت با تخفیف" v-model="productModel.price_with_off" :required="false">
								<span slot="suffix" class="ty-color-primary">تومان</span>
							</ty-currency-input>
						</ty-col>
					</ty-row>
				</ty-col>
				<ty-col :xs="24" :sm="17" :md="24" :lg="24" :xl="24">
					<ty-row :gutter="10">
						<ty-col :xs="24" :sm="7" :md="7" :lg="8" :xl="6">
							<ty-select :show-cancel="true" v-if="categories!==null" label="دسته بندی" v-model="productModel.category_id">
								<ty-option v-for="item in categories" :key="item.id" :label="item.name" :value="item.id" />
							</ty-select>
						</ty-col>
						<ty-col :xs="24" :sm="7" :md="7" :lg="8" :xl="6">
							<ty-select :show-cancel="true" v-if="brands!==null" label="برند" v-model="productModel.brand_id">
								<ty-option v-for="item in brands" :key="item.id" :label="item.name" :value="item.id" />
							</ty-select>
						</ty-col>
						<ty-col :xs="24" :sm="10" :md="10" :lg="8" :xl="7">
							<div>
								<ty-input-number :min="0" :max="1000" label="سود پیشفرض" v-model="productModel.predicted_percent">
									<div slot="suffix-outside" class="ty-color-primary mr-3 pt-5">درصد</div>
								</ty-input-number>
							</div>
						</ty-col>
					</ty-row>
					<ty-row>
						<ty-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" class="mt-4">
							<div class="ty-flex ty-gap-10">
								<ty-checkbox v-model="productModel.suggested"/>
								<div class="fs-xs-12 fs-sm-14">
									محصول پیشنهادی
								</div>
							</div>
						</ty-col>
						<ty-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" class="mt-4">
							<div class="ty-flex ty-gap-10">
								<ty-checkbox v-model="productModel.hide"/>
								<div class="fs-xs-12 fs-sm-14">
									محصول پنهان
								</div>
							</div>
						</ty-col>
					</ty-row>
				</ty-col>
				<ty-col>
					<ty-input label="توضیحات" class="w-100" type="textarea" v-model="productModel.description" />
				</ty-col>
			</ty-row>
			<div class="ty-flex mt-4">
				<ty-button v-if="!product.id" @click="create()" color="success" class="mr-auto" size="medium">ایجاد محصول</ty-button>
				<ty-button v-if="product.id" @click="update()" color="success" class="mr-auto" size="medium">ذخیره محصول</ty-button>
			</div>
		</form>
	</div>
</template>

<script>
import { Instance } from '@/classes/TayehApi';
	import UploadImage from '@/components/UploadImage.vue';
	export default {
		props: {
			product:  {
				type: Object,
				default: null
			},
			instanceId: {
				type: [Number, String],
				required: true
			}
		},
		components: {
			upload: UploadImage
		},
		data() {
			const {
				product
			} = this;
			return {
				productModel: {...product,
					image_id: product.image?product.image.id:null,
					category_id: product.category?product.category.id:null,
					brand_id: product.brand?product.brand.id:null},
				categories: null,
				brands: null,
			}
		},
		methods: {
			async create() {
				try {
					let res = await Instance.createProduct(this.instanceId, this.productModel)
					if (res.data.err) {
						this.$message({
							showClose: true,
							message: res.data.err,
							type: 'error',
							duration: 5000
						});
					} else {
						this.$message({
							showClose: true,
							message: 'محصول ذخیره شد.',
							type: 'success',
							duration: 5000
						});
					}
				} catch {
					this.$message({
						showClose: true,
						message: 'لطفا دوباره تلاش کنید.',
						type: 'error',
						duration: 5000
					});
				} finally {
					this.$emit('created')
				}
			},
			async update() {
				try {
					let res = await Instance.updateProduct(this.instanceId, this.productModel)
					if (res.data.err) {
						this.$message({
							showClose: true,
							message: res.data.err,
							type: 'error',
							duration: 5000
						});
					} else {
						this.$message({
							showClose: true,
							message: 'محصول ذخیره شد.',
							type: 'success',
							duration: 5000
						});
					}
				} catch {
					this.$message({
						showClose: true,
						message: 'لطفا دوباره تلاش کنید.',
						type: 'error',
						duration: 5000
					});
				} finally {
					this.$emit('updated')
				}
			},
			async getCategories() {
				try {
					this.categories = (await Instance.getCategories(this.instanceId)).data.objects;
				} catch (err) {
					console.log(err);
				}
			},
			async getBrands() {
				try {
					this.brands = (await Instance.getBrands(this.instanceId)).data;
				} catch (err) {
					console.log(err);
				}
			},
		},
		mounted() {
			this.getCategories()
			this.getBrands()
		}
	}
</script>